const chunkArray = <T>(arr: T[], size: number): Array<T[]> =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
        arr.slice(i * size, i * size + size)
    );
export default chunkArray;
